// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__13ADI","sendOtp":"AuthorizeToLogin_sendOtp__3AUVi"};